import { useFormContext } from '@oscar/form';
import { Col, Modal, Row, Table } from '@oscar/theme';
import { TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import './styles.scss';

interface Props {
  onClose: () => void;
  visible: boolean;
  data: any;
  label?: string;
}

const columnAttactment = [
  {
    title: 'No',
    dataIndex: 'index',
    key: 'index',
  },
  {
    title: 'Attachment',
    dataIndex: 'link',
    key: 'link',
    render: (link: any) => <a href={link.url}>{link.fileName}</a>,
  },
];

const ListAttchment = (props: any) => {
  const dataAtachment = props.listAttchment.map((elem: any, index: any) => {
    return {
      index: index + 1,
      id: elem.id,
      link: {
        fileName: elem.fileName,
        url: elem.url,
      },
    };
  });
  return (
    <div className="text-field">
      <div className="file-uploaded-detail-title">Attachment</div>
      <Table
        columns={columnAttactment}
        dataSource={dataAtachment}
        pagination={false}
      />
    </div>
  );
};
const ResultChecklist = (props: Props) => {
  const { onClose, visible, data, label } = props;
  const [formContext] = useFormContext();
  const metaDataPaintingValidationDetail =
    formContext.selectors?.getDataByKey('metaDataPaintingValidationDetail') ||
    {};

  const attchments = data?.paintingConditionExecution?.attachments;
  return (
    <div className="result-checklist">
      <Modal
        closable={true}
        bodyStyle={{ width: '100%' }}
        visible={visible}
        title={label}
        okText="Submit"
        cancelText="Back"
        footer={null}
        onCancel={() => onClose()}
        onOk={() => {
          onClose();
        }}
        width={1000}
      >
        {data?.surfacePrep && (
          <>
            <div className="result-header">Surface Prep</div>

            <Row className="list-row" gutter={12}>
              <Col span={12}>
                <TextField
                  label="Surface Prep"
                  value={data?.surfacePrep?.surfacePrep}
                  mappingData={
                    metaDataPaintingValidationDetail?.surfacePreparation
                  }
                />
              </Col>
              <Col span={12}>
                <TextField
                  label="Cleaning Method"
                  value={data?.surfacePrep?.cleaningMethod}
                />
              </Col>
            </Row>
            <Row className="list-row" gutter={12}>
              <Col span={12}>
                <TextField
                  label="Ave Surface Profile"
                  value={data?.surfacePrep?.aveSurfaceProfile}
                />
              </Col>
              <Col span={12}>
                <TextField
                  label="Abrasive Type"
                  value={data?.surfacePrep?.abrasiveType}
                />
              </Col>
            </Row>
            <Row className="list-row" gutter={12}>
              <Col span={12}>
                <TextField
                  label="Abrasive Sieve Size"
                  value={data?.surfacePrep?.abrasiveSieveSize}
                />
              </Col>
              <Col span={12}>
                <TextField
                  label="Pressure Used"
                  value={data?.surfacePrep?.pressureUsed}
                />
              </Col>
            </Row>
          </>
        )}

        <div className="result-header">Painting Condition Execution</div>
        <Row className="list-row" gutter={12}>
          <Col span={24}>
            <TextField
              label="Application Product"
              value={label?.substring(0, 8).toLowerCase()}
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={24}>
            <TextField
              label="Paint Product"
              value={data?.paintingConditionExecution?.paintProduct}
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              label="Paint Batch Number Part A"
              value={data?.paintingConditionExecution?.paintBatchNumberPathA}
            />
          </Col>
          <Col span={12}>
            <TextField
              label="Paint Batch Number Part B"
              value={data?.paintingConditionExecution?.paintBatchNumberPathB}
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={24}>
            <TextField
              value={data?.paintingConditionExecution?.equipmentUsed}
              label="Equipment Used"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.averageWFT}
              label="Average WFT (µm)"
            />
          </Col>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.averageDFT}
              label="Average DFT (µm)"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={24}>
            <TextField
              value={data?.paintingConditionExecution?.weather}
              label="Weather"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.relativeHumidity}
              label="Relative Humidity (%)"
            />
          </Col>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.dewPoint}
              label="Dew Point (°C)"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.dryBulbTemperature}
              label="Dry Bulb Temperature (°C)"
            />
          </Col>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.wetBulbTemperature}
              label="Wet Bulb Temperature (°C)"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.substrateTemperature}
              label="Substrate Temperature (°C)"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.workLeaderName}
              label={`Work Leader Name ${label?.substring(0, 8)}`}
            />
          </Col>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.paintingCompletion}
              label="Painting Completion"
              isDate
              formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.inspectedByName}
              label="Inspected By (Contractor CI)"
            />
          </Col>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.inspectionDateAndTime}
              label="Inspection Date & Time"
              isDate
              formartDate={FORMAT_DATE.FULL_DATETIME_HOUR}
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={24}>
            <TextField
              value={data?.paintingConditionExecution?.remarks}
              label="Remarks"
            />
          </Col>
        </Row>
        <Row className="list-row" gutter={12}>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.witnessByName}
              label="Witnessed by (MLNG CI)"
            />
          </Col>
          <Col span={12}>
            <TextField
              value={data?.paintingConditionExecution?.date}
              label="Date"
              isDate
              formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
            />
          </Col>
        </Row>
        {attchments && (
          <Row className="list-row" gutter={12}>
            <Col span={24}>
              <div className="list-acttachment">
                <ListAttchment listAttchment={attchments}></ListAttchment>
              </div>
            </Col>
          </Row>
        )}
      </Modal>
    </div>
  );
};

export default ResultChecklist;
